import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { auth } from "../../firebase-config";
import { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import { db, storage } from '../../firebase-config';
import {
  collection,
  addDoc,
  deleteDoc,
  getDocs,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./Blog.css"
const cookies = new Cookies();

function RTL() {
  const [moviesList, setMoviesList] = useState([]);
  const [fileupload, setFileupload] = useState(null);
  const [movies, setMovies] = useState("");
  const [blog, setBlog] = useState(false);
  const [blogtitle, setBlogtitle] = useState(false);
  const [blogimage, setBlogimage] = useState(false);
  const [blogcontent, setBlogcontent] = useState(false);



  const moviesCollectionRef = collection(db, "movies");

  useEffect(() => {
    const unsubscribe = onSnapshot(query(moviesCollectionRef, orderBy("createdAt")), (snapshot) => {
      let moviesData = [];
      snapshot.forEach((doc) => {
        moviesData.push({ ...doc.data(), id: doc.id, fav: false });
      });
      setMoviesList(moviesData);
    });

    return () => unsubscribe();
  }, []);


  const handleLikeClick = (id) => {
    setMoviesList(prevMoviesList => {
      return prevMoviesList.map(movie => {
        if (movie.id === id) {
          return { ...movie, fav: !movie.fav };
        }
        return movie;
      });
    });
  };

  return (
    !blog ? (
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <MDTypography>
            <MDBox py={3}>
              <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
                  <div style={{ position: 'relative' }}>
                    {moviesList.map((movie) => (
                      <Card key={movie.date} style={{ marginBottom: '3rem', backgroundColor: "#202940" }}>
                        <MDTypography style={{color: "white"}}>
                          <CardHeader
                            avatar={
                              <Avatar alt="Profile" src={movie.pfpimage} style={{cursor: "pointer"}} />
                            }
                            title={movie.username}
                          />
                        </MDTypography>
                        <CardMedia
                          component="img"
                          src={movie.date}
                          alt=""
                          style={{ objectFit: 'cover', cursor: "pointer" }}
                          onClick={() => {
                            setBlog(true)
                            setBlogtitle(movie.title)
                            setBlogimage(movie.date)
                            setBlogcontent(movie.text)
                          }
                          }
                        />
                        <CardContent style={{ marginTop: "2rem" }}>
                          <MDTypography variant="body2" style={{color:"white"}}>
                            {movie.text.length > 200 ? `${movie.text.slice(0, 200)}...` : movie.text}
                          </MDTypography>
                        </CardContent>

                        <CardActions style={{ justifyContent: "space-evenly", marginBottom: "4px" }}>
                          <IconButton aria-label="add to favorites" style={{ color: movie.fav ? 'red' : 'white' }} onClick={() => handleLikeClick(movie.id)}>
                            <FavoriteIcon />
                          </IconButton>
                          <IconButton aria-label="share" style={{ color: 'white', }}>
                            <ShareIcon />
                          </IconButton>
                          <IconButton
                            aria-label="show more"
                            style={{ color: 'white', }}
                          >
                            <SaveIcon />
                          </IconButton>
                        </CardActions>

                      </Card>
                    ))}
                  </div>
                </div>
            </MDBox>
          </MDTypography>
          <Footer />
        </DashboardLayout>
      </>
    ) : (
      <DashboardLayout>
        <MDTypography>
          <MDBox py={3}>
          <div className='bloggy' style={{ fontFamily: 'Arial, sans-serif', margin: '0 auto', padding: '20px' }}>
              <div style={{ position: 'relative' }}>
                <Card style={{ marginBottom: '3rem' }}>
                  <MDTypography>
                    <CardHeader
                      title={blogtitle.toUpperCase()}
                      style={{ textAlign: "center", fontWeight: "750"}}
                    />
                  </MDTypography>
                  <CardMedia
                    component="img"
                    src={blogimage}
                    alt=""
                    style={{ objectFit: 'cover', cursor: "pointer",}}
                  />
                  <CardContent style={{ marginTop: "2rem" }}>
                    <MDTypography variant="body3">
                      {blogcontent}
                    </MDTypography>
                  </CardContent>

                </Card>
                <MDButton onClick={() => {
                  setBlog(false)
                  setBlogimage("")
                  setBlogcontent("")
                }
                }>GO BACK</MDButton>
              </div>
            </div>
          </MDBox>
        </MDTypography>
      </DashboardLayout>
    )
  );
}

export default RTL;
